import PropTypes from 'prop-types';
import { useEffect, useCallback, useState } from 'react';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

//
import { useAuthContext } from '../hooks';
import { useMockedUser } from 'src/hooks/use-mocked-user';


// ----------------------------------------------------------------------

const loginPaths = {
  jwt: paths.auth.jwt.login,
  auth0: paths.auth.auth0.login,
  amplify: paths.auth.amplify.login,
  firebase: paths.auth.firebase.login,
};

// ----------------------------------------------------------------------

export default function AuthGuard({ children }) {

  const router = useRouter();

  const { user } = useMockedUser();


  const { method } = useAuthContext();

  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if (!user || (user?.user_type !== '3' && user?.user_type !== '4')) {
      const href = '/';
      router.replace(href);
    } else {
      setChecked(true);
    }
  }, [user, method, router]);


  useEffect(() => {
    check();
  }, []);

  if (!checked) {
    return null;
  }

  return <>{children}</>;
}

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export function AuthGuardSuperAdmin({ children }) {

  const router = useRouter();

  const { user } = useMockedUser();
  

  const { method } = useAuthContext();

  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if (!user || (user?.user_type != "1")) {
      const href = `/`;
      router.replace(href);
    } else {
      setChecked(true);
    }
  }, [user, method, router]);


  useEffect(() => {
    check();
  }, []);

  if (!checked) {
    return null;
  }

  return <>{children}</>;
}

AuthGuardSuperAdmin.propTypes = {
  children: PropTypes.node,
};

export function AuthGuardAdmin({ children }) {

  const router = useRouter();

  const { user } = useMockedUser();

  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if (!user || (user?.user_type != "2")) {
      const href = `/`;
      router.replace(href);
    } else {
      setChecked(true);
    }
  }, [user, router]);
  useEffect(() => {
    check();
  }, []);
  if (!checked) {
    return null;
  }
  return <>{children}</>;
}

AuthGuardAdmin.propTypes = {
  children: PropTypes.node,
};
